import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useIsRedesignEnabled } from "@src/appV2/redesign/hooks/useIsRedesignEnabled";
import { Platform } from "@src/mobile/utils/platform";

export function useIsSettingsRedesignEnabled(): boolean {
  const isSettingsRedesignEnabled = useCbhFlag(CbhFeatureFlag.SETTINGS_REDESIGN_ENABLED, {
    defaultValue: false,
  });
  const isRedesignEnabled = useIsRedesignEnabled();

  return isRedesignEnabled && (Platform.isMobile || isSettingsRedesignEnabled);
}
